"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDesiredLocale;

var _config = require("../../config");

/**
 * Returns the locale which is currently desired by the client.
 * However, the returned locale may or may not be supported by the framework.
 * To get the resulting and supported current locale, use getLocale() instead.
 */
function getDesiredLocale() {
  return localStorage.getItem(_config.STORAGE_KEY_DESIRED_LOCALE) || undefined;
}